// Nav entry of SentenceStack (shell/nav.ts collects every routes/*.nav.ts; `order` places it in the rail, the tabs and Lisää).
// Lausepino: the sentence stack's HV suggestions, approved by either user (content, not admin).
import { defineNav } from '../shell/nav-entry';

export const nav = defineNav({
  id: 'sentenceStack',
  path: '/sentence-stack',
  icon: 'sentenceStack',
  group: 'together',
  phone: 'more',
  order: 1300,
  load: () => import('./SentenceStack'),
});
